import { forwardRef } from 'react';
import MultiDayGridLayout from './MultiDayGridLayout';

/**
 * Template — multi-day "Court Availability" (every date in the range side by
 * side), light design.
 * @param {object} props
 * @param {object} props.snapshot - buildMultiDaySnapshot() output
 * @param {'ranges'|'hourly'} [props.rowMode] - 'hourly' forces one row per hour; 'ranges' merges hours when hourly rows would be too small
 * @param {object} [props.imageSettings] - Availability images settings (font sizes in px, BOOKED colours); see availabilityImageSettingsUtil
 * @returns {JSX.Element}
 */
const MultiDayLightTemplate = forwardRef(function MultiDayLightTemplate({ snapshot, rowMode, imageSettings }, ref) {
  return <MultiDayGridLayout ref={ref} snapshot={snapshot} rowMode={rowMode} imageSettings={imageSettings} variant="light" />;
});

export default MultiDayLightTemplate;
